"use client";

import { ImageWithSkeleton } from "@/components/ui/image-with-skeleton";

const LISTING_IMAGE_RATIO = 4 / 3;

function withListingCrop(src: string): string {
  try {
    const url = new URL(src);
    if (
      url.hostname === "images.unsplash.com" ||
      url.hostname.endsWith(".unsplash.com")
    ) {
      return src;
    }
  } catch {
    // Relative and local URLs can still opt into the custom loader crop.
  }

  const separator = src.includes("?") ? "&" : "?";
  return `${src}${separator}_cfRatio=${LISTING_IMAGE_RATIO}`;
}

interface ListingImageProps {
  src: string;
  alt: string;
  priority?: boolean;
}

export function ListingImage({
  src,
  alt,
  priority = false,
}: ListingImageProps) {
  return (
    <div className="relative w-full overflow-hidden rounded-sm bg-muted h-48 sm:h-auto sm:aspect-4/3">
      <ImageWithSkeleton
        src={withListingCrop(src)}
        alt={alt}
        fill
        className="h-full w-full rounded-sm object-cover object-[center_40%]"
        sizes="(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 33vw"
        priority={priority}
        loading={priority ? "eager" : "lazy"}
        fetchPriority={priority ? "high" : "low"}
        quality={70}
      />
    </div>
  );
}
